import { Box, Icon, Text } from "@prismicio/editor-ui"

import type { OnboardingTracking } from "../../service"

interface OnboardingTutorialProps {
  href: string
  tracking: OnboardingTracking
}
export function OnboardingTutorial(props: OnboardingTutorialProps) {
  const { href, tracking } = props

  return (
    <Box justifyContent="center" padding={{ block: 6 }}>
      <Text
        href={href}
        variant="smallBold"
        color="grey11"
        onClick={() =>
          void tracking.track({
            event: "shared-onboarding:follow-tutorial",
            source: tracking.source,
          })
        }
      >
        Or watch our in-depth course
        <Icon
          name="playCircle"
          color="grey11"
          size="small"
          sx={{ marginLeft: 4 }}
        />
      </Text>
    </Box>
  )
}
